import styled from 'styled-components'

export const Page = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  /* 상단 고정 헤더(로고 ~139px) 아래로 콘텐츠 내림 */
  padding: 160px 16px 80px;
  color: #e8ecf2;

  @media (max-width: 767px) {
    padding: 100px 12px 60px;
  }
`

export const BackBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px 0 12px;
  margin-bottom: 16px;
  background: #1a1f28;
  border: 1px solid #2a3240;
  border-radius: 8px;
  color: #c4ccd8;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s ease;

  svg { width: 16px; height: 16px; }
  &:hover { background: #232a37; color: #fff; border-color: #3a4152; }
`

export const Card = styled.section`
  background: #12161d;
  border: 1px solid #232935;
  border-radius: 14px;
  padding: 22px 24px;
  margin-bottom: 22px;

  @media (max-width: 767px) {
    padding: 16px 14px;
    border-radius: 12px;
    margin-bottom: 16px;
  }
`

export const CardTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 16px;
  font-weight: 700;
  color: #eef2f7;
  margin: 0 0 18px;
`

/* 타이틀 아이콘 (골드) — 은은한 배경 원 위 SVG */
export const TitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: linear-gradient(145deg, rgba(245,196,81,.18), rgba(245,196,81,.06));
  border: 1px solid rgba(245,196,81,.28);
  color: #f5c451;
  flex: none;

  svg { width: 17px; height: 17px; }
`

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`

/* 커스텀 드롭다운 (네이티브 select 대체) */
export const Dropdown = styled.div`
  position: relative;
  min-width: 140px;
`

export const DropdownBtn = styled.button`
  width: 100%;
  height: 40px;
  padding: 0 12px 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #1a1f28;
  border: 1px solid ${({ $open }) => ($open ? '#454b73' : '#2a3240')};
  border-radius: 8px;
  color: #dfe5ee;
  font-size: 13px;
  cursor: pointer;
  transition: border-color .15s ease;

  &:hover { border-color: #3a4152; }

  svg {
    width: 14px; height: 14px;
    color: #8a93a3;
    transition: transform .18s ease;
    transform: rotate(${({ $open }) => ($open ? '180deg' : '0')});
    flex: none;
  }
`

export const DropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 30;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #171c25;
  border: 1px solid #2a3240;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(0,0,0,.45);
  max-height: 280px;
  overflow-y: auto;
`

export const DropdownItem = styled.li`
  padding: 9px 12px;
  border-radius: 7px;
  font-size: 13px;
  color: ${({ $active }) => ($active ? '#fff' : '#c4ccd8')};
  background: ${({ $active }) => ($active ? '#3a3f63' : 'transparent')};
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: ${({ $active }) => ($active ? '#3a3f63' : '#232a37')}; }
`

export const SearchBtn = styled.button`
  height: 40px;
  padding: 0 22px;
  background: #3a3f63;
  border: 1px solid #454b73;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: #454b73; }
`

export const GroupLabel = styled.div`
  font-size: 12px;
  color: #8a93a3;
  margin: 14px 0 8px;
`

export const Tabs = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const Tab = styled.button`
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all .15s ease;
  background: ${({ $active, $variant }) =>
    $active ? ($variant === 'result' ? '#2f8f6f' : '#e08e3c') : '#1a1f28'};
  border: 1px solid ${({ $active, $variant }) =>
    $active ? ($variant === 'result' ? '#38a983' : '#e79a4f') : '#2a3240'};
  color: ${({ $active }) => ($active ? '#fff' : '#c4ccd8')};
`

/* 테이블 */
export const TableWrap = styled.div`
  overflow-x: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
  font-size: 13px;
`

export const Th = styled.th`
  text-align: ${({ $align }) => $align || 'center'};
  padding: 14px 12px;
  color: #8a93a3;
  font-weight: 600;
  border-bottom: 1px solid #232935;
  white-space: nowrap;
`

export const Td = styled.td`
  text-align: ${({ $align }) => $align || 'center'};
  padding: 14px 12px;
  color: #dfe5ee;
  border-bottom: 1px solid #1b2028;
  white-space: nowrap;
`

export const Empty = styled.div`
  text-align: center;
  color: #6b7688;
  padding: 60px 0;
  font-size: 14px;
`

/* ── 모바일 카드 리스트 (테이블 대체) ── */
export const MList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const MCard = styled.div`
  background: #161b23;
  border: 1px solid #232935;
  border-radius: 12px;
  padding: 13px 14px;
`

export const MHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #1b2028;

  .name { font-size: 14px; font-weight: 700; color: #eef2f7; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`

export const MRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
  font-size: 13px;

  .k { color: #8a93a3; flex: none; }
  .v { color: #dfe5ee; text-align: right; }
  .v.win { color: #2fbf8f; font-weight: 700; }
`

export const MEmpty = styled.div`
  text-align: center;
  color: #6b7688;
  padding: 48px 0;
  font-size: 14px;
`

export const ResultBadge = styled.span`
  display: inline-block;
  min-width: 52px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: ${({ $code }) =>
    $code === 'W' ? '#2f8f6f' :
    $code === 'L' ? '#6b7280' :
    $code === 'C' ? '#8a5a5a' :
    $code === 'T' ? '#e08e3c' : '#4b5169'};
`

export const Pager = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 20px;
`

export const PageBtn = styled.button`
  min-width: 34px; height: 34px;
  border-radius: 7px;
  background: ${({ $active }) => ($active ? '#3a3f63' : '#1a1f28')};
  border: 1px solid ${({ $active }) => ($active ? '#454b73' : '#2a3240')};
  color: ${({ $active }) => ($active ? '#fff' : '#c4ccd8')};
  font-size: 13px;
  cursor: pointer;
  &:disabled { opacity: .4; cursor: default; }
`
